import _typeof from 'babel-runtime/helpers/typeof';
export default function getDataSet(elemArr) {
    var _loop = function _loop(i) {
        if (elemArr[i] && elemArr[i].dataset && elemArr[i].dataset.uplusId) {
            var data = {};
            Object.keys(elemArr[i].dataset).forEach(function (item) {
                if (String(item).toLowerCase().substring(0, 5) === 'uplus' && String(item).toLowerCase() !== 'uplusid' && elemArr[i].dataset[item]) {
                    data[item] = elemArr[i].dataset[item];
                }
            });
            return {
                v: { id: elemArr[i].dataset.uplusId, dataType: elemArr[i].dataset.uplusType, data: data }
            };
        }
    };

    for (var i = 0; i < elemArr.length; i++) {
        var _ret = _loop(i);

        if ((typeof _ret === 'undefined' ? 'undefined' : _typeof(_ret)) === "object") return _ret.v;
    }
    return null;
}